__turbopack_context__.v({
  "anchorColor": "_5TkmXW_anchorColor",
  "listPadding": "_5TkmXW_listPadding",
  "textDefaults": "_5TkmXW_textDefaults",
  "unsizedText": "_5TkmXW_unsizedText",
});
